import { FC } from 'react'
import { Box } from '@mui/material'
import { Refresh } from '@mui/icons-material'
import moment from 'moment'
import Decline from '../icons/decline'
import { getCurrency } from '../../lib/currency'

interface IAverageRent {
  annual?: string | number
  avgRent?: string | number
  sqft?: string | number
  updateTime?: string | number
  annualMeanPriceChange?: string | number
}

const Avg: FC<{ averageRent: IAverageRent }> = ({ averageRent = {} }) => {
  const {
    annual = '',
    avgRent = '',
    sqft = '',
    updateTime = null,
    annualMeanPriceChange = ''
  } = averageRent || {}

  return (
    <Box className="relative">
      <Box className="flex mt-6">
        <Refresh className="w-4 mr-2" />
        <div className="font-averta text-primary text-base">
          Last updated on {updateTime ? moment(updateTime).format('MMMM YYYY') : ''}
        </div>
      </Box>
      <Box className="p-6 flex justify-between mt-6 border-gray-300 border rounded-2xl gap-1 lg:gap-5">
        <Box component="div" className="lg:min-w-[33%] h-full flex flex-col justify-between">
          <div className="text-secondary text-sm text-center lg:text-left h-10 lg:h-auto">
            Avg.rent
          </div>
          <div className="text-primary font-semibold text-xl text-center lg:text-left lg:text-[28px] lg:leading-9 mt-2">
            ${avgRent && getCurrency(avgRent, 0)} /mo
          </div>
        </Box>
        <Box component="div" className="lg:min-w-[33%] h-full flex flex-col justify-between">
          <div className="text-secondary text-sm text-center lg:text-left h-10 lg:h-auto">
            Avg.apartment size
          </div>
          <div className="text-primary font-semibold text-xl text-center lg:text-left lg:text-[28px] lg:leading-9 mt-2">
            {Math.floor(~~sqft)} Sq.Ft
          </div>
        </Box>
        {annual === 0.0 ? (
          <Box component="div" className="lg:min-w-[33%] h-full flex flex-col justify-between">
            <div className="text-secondary text-sm text-center lg:text-left h-10 lg:h-auto">
              Annual change
            </div>
            <Box component="div" className="lg:flex items-center mt-2">
              <div className="text-primary font-semibold text-xl text-center lg:text-left lg:text-[28px] lg:leading-9">
                {!Number.isNaN(parseFloat(annual.toString())) && parseFloat(annual.toString()) > 0
                  ? '+'
                  : ''}
                {!Number.isNaN(parseFloat(annual.toString()))
                  ? (parseFloat(annual.toString()) * 100).toFixed(1)
                  : '--'}
                %
              </div>
              {!Number.isNaN(parseFloat(annual.toString())) && parseFloat(annual.toString()) < 0 ? (
                <div className="px-2 py-[5px] flex items-center bg-red-50 rounded-[18px] lg:ml-2 mt-1 lg:mt-0 w-fit mx-auto">
                  <Decline className="text-xs" />
                  <Box component="div" className="text-red text-xs font-semibold ml-1">
                    ${Math.trunc(~~annualMeanPriceChange)}
                  </Box>
                </div>
              ) : (
                ''
              )}
            </Box>
          </Box>
        ) : (
          <Box component="div" className="hidden lg:block lg:w-1/3" />
        )}
      </Box>
    </Box>
  )
}

export default Avg
